import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ESidebarMode } from 'app/enums/sidebarmode.enum';
import { ISidebar } from 'app/interfaces/sidebar.interface';
import { GlobalService } from 'app/services/global.service';
import { DateTime } from 'luxon';
import { AppointmentSidebarService } from 'modules/appointments/services/appointment-sidebar.service';
import { ReplaySubject } from 'rxjs';

@Component({
	selector: 'app-financials',
	templateUrl: './financials.component.html',
	styleUrls: ['./financials.component.scss'],
})
export class FinancialsComponent implements OnInit {
	// Sidebar data.
	activeSidebar: ISidebar;
	calendarLabels: any;
	sidebarVisible: string;
	modalVisible: ESidebarMode;
	isMobile = false;
	// Refresh profile Completion
	public resetProfileCompletion: ReplaySubject<boolean> =
		new ReplaySubject<boolean>();
	public showHideDetails: ReplaySubject<boolean> = new ReplaySubject<boolean>();
	// Constructor.
	constructor(
		protected global: GlobalService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected translate: TranslateService,
		public sidebarService: AppointmentSidebarService
	) {
		this.resetProfileCompletion.next(true);
	}

	// On Init.
	public ngOnInit(): void {
		this.isMobile = this.global.isMobileDevice();

		// Active sidebar.
		this.activeSidebar = {
			id: null,
			date: new Date(),
			mode: ESidebarMode.Appointments,
		};
		this.changeActiveSidebar(this.activeSidebar);
	}

	// Show details of an event.
	public selectedEvent(eventId: string): void {
		// Active sidebar.
		this.activeSidebar = {
			date: new Date(),
			id: eventId,
			mode: ESidebarMode.Details,
			contactId: null,
			scrollTo: true,
		};
		this.changeActiveSidebar(this.activeSidebar);
	}

	// On window resize.
	public onResize(): void {
		// Update mobile info.
		this.isMobile = this.global.isMobileDevice();
	}

	// Reschedule.
	public reschedule(sb: ISidebar): void {
		sb.mode = ESidebarMode.Edit;
		this.changeActiveSidebar(sb);
	}

	// Change sidebar content.
	protected async changeActiveSidebar(sidebar: ISidebar) {
		this.activeSidebar = sidebar;

		this.sidebarVisible = 'Appointments';
		this.modalVisible = sidebar.mode;

		this.showHideDetails.next(
			this.sidebarVisible !== 'Appointments' || !this.sidebarVisible
		);

		if (
			this.activeSidebar.mode === ESidebarMode.New ||
			this.activeSidebar.mode === ESidebarMode.Edit
		) {
			await this.sidebarService.setSidebar(true, this.activeSidebar);
		}
	}

	public getTimeByString(date, hour) {
		const _date = DateTime.fromJSDate(date);
		const _hour = DateTime.fromFormat(hour, 'HH:mm');

		_date.set({ hour: _hour.hour, minute: _hour.minute, second: 0 });
		return _date.toJSDate();
	}
}
